import { RouteObject } from 'react-router-dom'
import { StoreFactsPage } from './store-facts'

export const StoreFactsRoute: RouteObject = {
    path: '/store-facts',
    element: <StoreFactsPage />,
}
